import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UserProfile } from '../../../user-profile/user-profile';
import { BaseComponent } from '../../../base-component';
import { FormService } from '../form.service';

@Component({
  standalone: false,
  selector: 'mtn-user-profile-form',
  templateUrl: './user-profile-form.component.html',
  styleUrls: ['./user-profile-form.component.scss']
})
export class UserProfileFormComponent extends BaseComponent implements OnInit {

  @Input()
  controlName = 'userProfile';
  @Input()
  parentForm: UntypedFormGroup;
  @Input()
  userProfile: UserProfile;

  form = new UntypedFormGroup({});

  constructor(private formService: FormService) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.formService.buildUserProfileForm(this.userProfile);
    this.parentForm.addControl(this.controlName, this.form);
  }

}
